import { Injectable } from '@angular/core';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';

 /** A router wrapper, adding extra functions. */
@Injectable()
export class RouterExtService {

  private previousUrl: string = undefined;
  private currentUrl: string = undefined;
  private previousRoute: string = undefined;
  private currentRoute: string = undefined;
  private firstLoad: boolean;
  private currentParams: string = undefined;

  constructor(
    private router: Router
  ) {
    this.firstLoad = true;
    this.currentUrl = window.location.href;
    this.currentRoute = this.router.url;

    router.events.subscribe(
      (event) => {
        if (event instanceof NavigationEnd) {
          this.parseEvent(event);
        }
      }
    );
  }

  private parseEvent(event: NavigationEnd) {
    if (this.previousUrl !== this.currentUrl && !this.firstLoad) {
      this.previousUrl = this.currentUrl;
      this.previousRoute = this.currentRoute;
    }
    this.firstLoad = false;
    this.currentUrl = window.location.href;
    this.currentRoute = event.url;
    if (this.currentRoute.indexOf('?') > -1) {
      this.currentRoute = this.currentRoute.slice(0, this.currentRoute.indexOf('?'));
      this.currentParams = event.url.substr(event.url.indexOf('?') + 1);
    }
  }

  public getPreviousUrl() {
    return this.previousUrl;
  }

  public getCurrentUrl() {
    return this.currentUrl;
  }

  public getPreviousRoute() {
    return this.previousRoute;
  }

  public getCurrentRoute() {
    return this.currentRoute;
  }

  public getCurrentParams() {
    return this.getCurrentParams;
  }

  public getSelectedLocation() {
    const url = this.currentUrl.toString().match(/^(?:\/)\w+(?:\/)[0-9]{1,5}(?:\/)\w+(?:)/);
    if (url !== undefined && url !== null) {
      return url[0];
    }
    return this.currentUrl;
  }
}
